export { default } from "./ResultsDetailInfo";